// Styles for __name__ go here.
import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const StyledTab = styled.div`
  .m-standard-tab-list {
    overflow-x: scroll;
    width: 100%;
    border-bottom: ${toRem(1)} solid ${baseVariables.color['neutral40']};
    .m-standard-tab-list-item {
      min-width: ${toRem(74)};
      border-width: ${toRem(2)};
      display: inline-table;
      button {
        width: 100%;
        height: 100%;
      }

      &:not(:first-child) {
        button {
          padding: ${toRem(0)} ${toRem(24)};
        }
      }
    }
  }
  .tabTitleText,
  .tab-subtitle {
    color: ${baseVariables.color['neutral40']};
    font-weight: 700;
  }
  .active {
    .tabTitleText,
    .tab-subtitle {
      color: ${baseVariables.color['merch30']};
    }
  }
  .tabpage-border {
    border: ${toRem(1)} solid ${baseVariables.color['neutral30']};
  }
`;
